import { render } from "./GraciasPrincipal.vue?vue&type=template&id=69cfead7"
import script from "./GraciasPrincipal.vue?vue&type=script&lang=js"
export * from "./GraciasPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__